'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import CategoryChips from '@/widgets/ServiceLanding/CategoryChips';

import { productsCopy } from '@/constants/brandLanding';

import { BrandCategoryFilterProps } from './models';

const ALL_CATEGORIES_ID = 'all';

const BrandCategoryFilter = ({ categories, activeCategoryId }: BrandCategoryFilterProps) => {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const handleCategoryClick = (categoryId: string) => {
        const nextCategoryId = categoryId === ALL_CATEGORIES_ID ? null : Number(categoryId);
        if (nextCategoryId === activeCategoryId) return;

        const params = new URLSearchParams(searchParams.toString());
        if (nextCategoryId == null) {
            params.delete('categoryId');
        } else {
            params.set('categoryId', String(nextCategoryId));
        }
        const query = params.toString();
        router.replace(query ? `${pathname}?${query}` : pathname, { scroll: false });
    };

    if (!categories.length) {
        return null;
    }

    return (
        <CategoryChips
            items={[
                { id: ALL_CATEGORIES_ID, label: productsCopy.allCategories },
                ...categories.map((category) => ({ id: String(category.id), label: category.name }))
            ]}
            activeId={activeCategoryId == null ? ALL_CATEGORIES_ID : String(activeCategoryId)}
            onSelect={handleCategoryClick}
        />
    );
};

export default BrandCategoryFilter;
